import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _0d0483d3 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _05f94de5 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _75f66970 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _0eae439c = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _64f52efd = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _76126d1e = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _0e755926 = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _343835bf = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _3376e428 = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _7520f380 = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _02ecf07a = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _691f2636 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _386b94f6 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _6ce194c3 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _29acc458 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _555564f1 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _1fc4478a = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _61ff8031 = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _d60805f2 = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _4c08f597 = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _27cf02fc = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _79174702 = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _1c49f0a1 = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _486e56d6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _d590ffba = () => interopDefault(import('../src/pages/companies/_company_id/projects/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/member-allocation/index" */))
const _78d3478d = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _651d72a7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _77bd1fea = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _19878d44 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _54a46d55 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _fbd17eaa = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _1839ece9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _060e12b2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _7511d39a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _077b9b72 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _7da03398 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _1c3efdd2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _552a10be = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _ac601a7c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _b725365e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _f944d43a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _5ecdb44e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _7d139562 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _3850766a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _8e266d30 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _43bf0ee0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _747a7910 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _4606b085 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _2d2516f9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _09eca6f2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _53e86d9a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _62f24621 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _4885d61a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _396e1630 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _d5a33dd8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _418193a8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _0093d370 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _3a28cebe = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _3e1945b0 = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _e218e714 = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _522f36ae = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _44f5cada = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _cd14934a = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _aba02b4e = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _32930449 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _2cf18fa2 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _1358b591 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _5f0176bb = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _526a70e7 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _0280e347 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _0d0483d3,
      name: "companies"
    }, {
      path: "/logout",
      component: _05f94de5,
      name: "logout"
    }, {
      path: "/maintenance",
      component: _75f66970,
      name: "maintenance"
    }, {
      path: "/sign_in",
      component: _0eae439c,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _64f52efd,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _76126d1e,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _0e755926,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _343835bf,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/callback",
      component: _3376e428,
      name: "sessions-callback"
    }, {
      path: "/sessions/invitation",
      component: _7520f380,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _02ecf07a,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _691f2636,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _386b94f6,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _6ce194c3,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _29acc458,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _555564f1,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _1fc4478a,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _61ff8031,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _d60805f2,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _4c08f597,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _27cf02fc,
      children: [{
        path: "",
        component: _79174702,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _1c49f0a1,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _486e56d6,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "member-allocation",
        component: _d590ffba,
        name: "companies-company_id-projects-member-allocation"
      }, {
        path: "new",
        component: _78d3478d,
        name: "companies-company_id-projects-new"
      }, {
        path: ":id",
        component: _651d72a7,
        children: [{
          path: "",
          component: _77bd1fea,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _19878d44,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _54a46d55,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _fbd17eaa,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _1839ece9,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "member",
          component: _060e12b2,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _7511d39a,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _077b9b72,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _7da03398,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _1c3efdd2,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _552a10be,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _ac601a7c,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _b725365e,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _f944d43a,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _5ecdb44e,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _7d139562,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _3850766a,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _8e266d30,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _43bf0ee0,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _747a7910,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _4606b085,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _2d2516f9,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _09eca6f2,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _53e86d9a,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _62f24621,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _4885d61a,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _396e1630,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _d5a33dd8,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _418193a8,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _0093d370,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _3a28cebe,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _3e1945b0,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _e218e714,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _522f36ae,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _44f5cada,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _cd14934a,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _aba02b4e,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _32930449,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _2cf18fa2,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _1358b591,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _5f0176bb,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _526a70e7,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _0280e347,
      name: "index"
    }],

    fallback: false
  })
}
